import SearchResults, { SearchResultsProps } from "./SearchResults";

export interface SearchResultsInnerContainerProps {
    fetchMetadata: () => SearchResultsProps;
    className?: string;
    showSearchResults?: boolean;
}

/**
 * explore search-result reasons inner container
 */
export function SearchResultsInnerContainer({
    className,
    fetchMetadata,
    showSearchResults = false,
}: SearchResultsInnerContainerProps) {
    const info = fetchMetadata();

    return <SearchResults {...info} className={className} showSearchResults={showSearchResults} />;
}

export default SearchResultsInnerContainer;
